module.exports = __webpack_public_path__ + "static/media/close-white.5128824e.svg";